import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import PopupFile from './PopupFile';
import PopupUrl from './AddUrlPopup';
import FaqEmptyScreen from './FaqEmptyScreen';
import FaqFillScreen from './FaqFillScreen';
import { FaRegFileAlt } from 'react-icons/fa';
import { RiLink } from 'react-icons/ri';
import { deleteFaqDocument, uploadFaqDocuments } from '../../../../../api/AccountSetup';
import ToastNotification from '../../../../../common/ToastNotification';
import AccountSetupButton from '../../../../../common/AccountSetupButton';
import { HOSPITALITY_LIST, RETAILER_LIST } from '../../DATA';
import CostomTooltip from '../../../../../common/CostomTooltip';
import { getSubscriptionDetail } from '../../../../../common/CommonFunction';

interface faqAutoProps {
  documentList: any;
  fetchAllDocuments: any;
  fetchGeneratedFAQ: any;
  disable: any;
  isLoading: boolean;
  setIsLoading: any;
  setDocumentList: any;
}

const FaqAuto = (props: faqAutoProps) => {
  const {
    documentList,
    fetchAllDocuments,
    fetchGeneratedFAQ,
    disable,
    isLoading,
    setIsLoading,
    setDocumentList
  } = props;

  const companyUuid = sessionStorage.getItem('companyUuid');
  const shopId = sessionStorage.getItem('shopId');
  const businessType = sessionStorage.getItem('businessType');

  const [isPopupOpenFile, setIsPopupOpenFile] = useState(false);
  const [isPopupOpenUrl, setIsPopupOpenUrl] = useState(false);
  const [editUrlPopupData, setEditUrlPopupData] = useState();
  const [shouldUpload, setShouldUpload] = useState(false);
  const [subscriptionData, setSubscriptionData] = useState<any>(null);

  const navigate = useNavigate();
  const openPopup2 = () => {
    setIsPopupOpenUrl(true);
  };

  const closePopup1 = () => {
    setIsPopupOpenFile(false);
  };

  const closePopup2 = () => {
    setEditUrlPopupData(undefined);
    setIsPopupOpenUrl(false);
  };

  const deleteDocuments = async (documentId: string) => {
    setIsLoading(true);
    const res = await deleteFaqDocument(documentId, companyUuid ? companyUuid : '');
    if (res.ok) {
      getSubscriptionDetail(businessType, shopId);
      setDocumentList((documents: any) => documents.filter((doc: any) => doc.uuid != documentId));
      ToastNotification({
        message: 'Deleted Successfully',
        type: 'success'
      });

      fetchAllDocuments();
      setIsLoading(false);
    }
    setIsLoading(false);
  };
  const handleEditUrl = (info: any) => {
    setEditUrlPopupData(info);
    setIsPopupOpenUrl(true);
  };

  useEffect(() => {
    setTimeout(() => {
      const subscriptionPlanDetail = sessionStorage.getItem('planDetail');
      if (subscriptionPlanDetail) {
        setSubscriptionData(JSON.parse(subscriptionPlanDetail));
      }
    }, 100);
  }, [documentList]);

  const handleFileChange = async (event: React.ChangeEvent<HTMLInputElement>) => {
    const files = event.target.files;
    if (
      files &&
      (files.length >= subscriptionData.data.ai ||
        subscriptionData.data.aiCount >= subscriptionData.data.ai ||
        files.length + subscriptionData.data.aiCount + documentList.length >=
          subscriptionData.data.ai)
    ) {
      if (
        files.length + documentList.length + subscriptionData.data.aiCount >
        subscriptionData.data.ai
      ) {
        const count =
          subscriptionData.data.ai - (documentList.length + subscriptionData.data.aiCount);
        count > 0
          ? alert(`You can only upload up to ${count} files.`)
          : alert(`You can't add more files.`);
        return null;
      }
      if (
        files.length ===
        subscriptionData.data.ai - (documentList.length + subscriptionData.data.aiCount)
      ) {
      } else {
        alert(
          `You can only upload up to ${subscriptionData.data.ai - (documentList.length + subscriptionData.data.aiCount)} files.`
        );
        return null;
      }
    }
    if (!files) return;
    Array.from(files).forEach((file) => {
      setDocumentList((prevFiles: any) => [...prevFiles, file]);
    });
    setShouldUpload(true);
  };
  useEffect(() => {
    if (shouldUpload && documentList.length > 0) {
      uploadDocuments();
      setShouldUpload(false);
    }
  }, [documentList]);

  const uploadDocuments = async () => {
    if (documentList.length > 0) {
      try {
        setIsLoading(true);
        const res = await uploadFaqDocuments(documentList, companyUuid ? companyUuid : '');
        if (res.message === 'Successful') {
          getSubscriptionDetail(businessType, shopId);
          setIsLoading(false);
          ToastNotification({
            message: 'Documents Added Successfully',
            type: 'success'
          });
          fetchAllDocuments();
        } else {
          setIsLoading(false);
          ToastNotification({
            message: res.message,
            type: 'error'
          });
        }
      } catch (error: any) {
        setIsLoading(false);
        ToastNotification({
          message: 'Something went wrong',
          type: 'error'
        });
      }
    } else {
      ToastNotification({
        message: 'Please select document',
        type: 'error'
      });
    }
  };

  const checkLinkorFileValidation = () => {
    if (
      subscriptionData &&
      subscriptionData?.data?.analytics === 'Free' &&
      subscriptionData?.data?.ai >= 0
    ) {
      return true;
    }
    if (
      subscriptionData &&
      subscriptionData?.data?.analytics === 'Pro' &&
      (subscriptionData?.data?.aiCount >= subscriptionData.data.ai ||
        documentList?.length >= subscriptionData.data.ai)
    ) {
      return true;
    }
    if (
      subscriptionData &&
      subscriptionData?.data?.analytics === 'Advanced' &&
      (subscriptionData?.data?.aiCount >= subscriptionData.data.ai ||
        documentList?.length + subscriptionData?.data?.aiCount >= subscriptionData.data.ai)
    ) {
      return true;
    }
    return false;
  };

  return (
    <div className="w-full">
      <div className="flex flex-col mr-7 ml-9 gap-4">
        <label className="text-sm font-medium">
          Please select how you would like to upload the document.
        </label>

        {/* <div className="flex space-x-4">
          <CostomTooltip
            text={`Your current plan does not support adding documents. Please upgrade to continue.`}
            position="bottom"
            isDisabled={checkLinkorFileValidation()}
          >
            <div
              className="bg-[#006BEA] rounded flex justify-center items-center cursor-pointer p-2 text-sm gap-1 font-medium"
              onClick={() =>
                checkLinkorFileValidation()
                  ? null
                  : document.getElementById('fileUploadInput')?.click()
              }
            >
              <FaRegFileAlt />
              <label className="cursor-pointer">Upload file</label>
              {subscriptionData &&
                subscriptionData.data.analytics === 'Pro' &&
                subscriptionData.data.ai > documentList.length && (
                  <input
                    type="file"
                    id="fileUploadInput"
                    className="hidden"
                    onChange={handleFileChange}
                    accept="application/pdf"
                  />
                )}
              {subscriptionData &&
                subscriptionData.data.analytics === 'Advanced' &&
                subscriptionData.data.ai > documentList.length && (
                  <input
                    type="file"
                    id="fileUploadInput"
                    className="hidden"
                    multiple
                    onChange={handleFileChange}
                    accept="application/pdf"
                  />
                )}
            </div>
          </CostomTooltip>

          <CostomTooltip
            text={`Your current plan does not support upload links. Please upgrade to continue.`}
            position="bottom"
            isDisabled={checkLinkorFileValidation()}
          >
            <div
              className="bg-[#006BEA] rounded flex justify-center items-center cursor-pointer p-2 text-sm gap-1 font-medium"
              onClick={() => (checkLinkorFileValidation() ? null : openPopup2())}
            >
              <RiLink />
              <label className="cursor-pointer">Upload link</label>
            </div>
          </CostomTooltip>
        </div> */}
        <div className="flex space-x-4">
          {/* Upload File */}
          <div
            className="bg-[#006BEA] rounded flex justify-center items-center cursor-pointer p-2 text-sm gap-1 font-medium"
            onClick={() => {
              if (checkLinkorFileValidation()) {
                const confirmUpgrade = window.confirm(
                  'This feature is not included in your current plan - do you want to upgrade?'
                );
                if (confirmUpgrade) {
                  // You can redirect to upgrade page or open your custom upgrade modal
                  sessionStorage.setItem('redirectFrom', window.location.pathname);
                  navigate(
                    `/subscription?recentPlanType=${subscriptionData?.data?.analytics}&updatePlan=${true}`
                  );
                }
              } else {
                document.getElementById('fileUploadInput')?.click();
              }
            }}
          >
            <FaRegFileAlt />
            <label className="cursor-pointer">Upload file</label>

            {subscriptionData?.data?.analytics === 'Pro' &&
              subscriptionData?.data?.ai > documentList.length && (
                <input
                  type="file"
                  id="fileUploadInput"
                  className="hidden"
                  onChange={handleFileChange}
                  accept="application/pdf"
                />
              )}

            {subscriptionData?.data?.analytics === 'Advanced' &&
              subscriptionData?.data?.ai > documentList.length && (
                <input
                  type="file"
                  id="fileUploadInput"
                  className="hidden"
                  multiple
                  onChange={handleFileChange}
                  accept="application/pdf"
                />
              )}
          </div>

          {/* Upload Link */}
          <div
            className="bg-[#006BEA] rounded flex justify-center items-center cursor-pointer p-2 text-sm gap-1 font-medium"
            onClick={() => {
              if (checkLinkorFileValidation()) {
                const confirmUpgrade = window.confirm(
                  'This feature is not included in your current plan - do you want to upgrade?'
                );
                if (confirmUpgrade) {
                  sessionStorage.setItem('redirectFrom', window.location.pathname);
                  navigate(
                    `/subscription?recentPlanType=${subscriptionData?.data?.analytics}&updatePlan=${true}`
                  );
                }
              } else {
                openPopup2();
              }
            }}
          >
            <RiLink />
            <label className="cursor-pointer">Upload link</label>
          </div>
        </div>
      </div>

      <div className="bg-[#343434] px-5 ml-9 m-7 mb-0 rounded-lg overflow-y-auto h-[170px]">
        {isLoading ? (
          <>
            <div className="fixed inset-0 bg-black bg-opacity-50 z-40"></div>
            <div className="fixed inset-0 flex items-center justify-center z-50">
              <div className="loader border-t-4 border-[#006BEA] rounded-full w-12 h-12 animate-spin"></div>
            </div>
          </>
        ) : documentList?.length > 0 ? (
          <FaqFillScreen
            documentList={documentList}
            deleteDocuments={(documentId: string) => deleteDocuments(documentId)}
            handleEditUrl={handleEditUrl}
          />
        ) : (
          <FaqEmptyScreen />
        )}
      </div>

      {documentList.length > 0 && (
        <div className="flex justify-end -mb-6 -mt-7 mr-7">
          <AccountSetupButton
            isFormValid={true}
            btnText="Submit"
            textColor="#FFFFFF"
            backGroundColor="#006BEA"
            borderColor="#006BEA"
            onClick={fetchGeneratedFAQ}
            disable={disable}
          />
        </div>
      )}

      {/* <div className="fixed  bottom-2 right-6 gap-2 md:gap-4 bg-[#1E1E1E]">
          <div className="flex gap-7  -mt-10 ">
            <AccountSetupButton
              isFormValid={true}
              btnText="Skip"
              textColor="#FFFFFF"
              backGroundColor=""
              borderColor="#006BEA"
              onClick={() => navigate('/account-setup/widgets')}
            />

            {documentList.length > 0 && (
              <AccountSetupButton
                isFormValid={true}
                btnText="Next"
                textColor="#FFFFFF"
                backGroundColor="#006BEA"
                borderColor="#006BEA"
                onClick={fetchGeneratedFAQ}
                disable={disable}
              />
            )}
          </div>
        </div> */}

      {isPopupOpenFile && (
        <PopupFile
          onClose={closePopup1}
          fetchAllDocuments={fetchAllDocuments}
          setIsLoading={setIsLoading}
        />
      )}
      {isPopupOpenUrl && (
        <PopupUrl
          onClose={closePopup2}
          fetchAllDocuments={fetchAllDocuments}
          editUrlPopupData={editUrlPopupData}
          closePopup2={closePopup2}
          subscriptionData={subscriptionData}
          documentList={documentList}
        />
      )}

      {disable && (
        <>
          <div className="fixed inset-0 bg-black bg-opacity-50 z-40"></div>

          <div className="fixed inset-0 flex items-center justify-center z-50">
            <div className="loader border-t-4 border-[#006BEA] rounded-full w-12 h-12 animate-spin"></div>
          </div>
        </>
      )}
    </div>
  );
};

export default FaqAuto;
